<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
      <p class="modal-title">{{data.nzTitle}}</p>
    </div>

    <div class="flex justify-end">
        <button type="button" (click)="openSearchArticlesModal()" class="p-2">
            <img src="assets/icons/plus-icon.svg" alt="Añadir formatos" class="h-6 w-6"
                title="Añadir formatos" />
        </button>

        <textarea #myInput nz-input class="w-full h-10 px-3 py-2 border border-gray-300 rounded-md resize-none overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Escanee codigo de barras"
            rows="1"
            [(ngModel)]="textAreaBatchSearchValue"
            (input)="onArticleBatchSearch()">
        </textarea>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (rawMaterials && rawMaterials.length > 0) {
            <nz-table
                #basicTable
                [nzData]="rawMaterials"
                class="m-0 p-0"
                nzSize="small"
                [nzLoading]="isLoading"
                nzTableLayout="auto"
                [nzBordered]="true"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzScroll]="{ y: (tableHeight || 0) + 'px' }"
                >
                <thead>
                <tr>
                    <th id="article" nzWidth="20%">Artículo</th>
                    <th id="batch" nzWidth="20%">Lote</th>
                    <th id="packaging" nzWidth="20%">Formato</th>
                    <th id="quantity"nzWidth="10%">Cantidad a consumir</th>
                    <th id="action" nzWidth="10%">Acciones</th>
                </tr>
                </thead>
                <tbody>
                @for (rawMaterial of basicTable.data; track rawMaterial; let idx = $index) {
                    <tr>
                        <td>
                            {{rawMaterial.article?.name}}
                        </td>
                        <td>
                            {{rawMaterial.articleBatch?.batchNumber}}
                        </td>
                        <td>
                            {{rawMaterial.usedPackaging?.packagingType?.name}} {{(rawMaterial.usedPackaging?.externalBatchNumber || rawMaterial.usedPackaging?.batchNumber)}}
                        </td>
                        <td>
                            @if(canEdit(rawMaterial.createdById)){
                                <nz-input-group [nzSuffix]="rawMaterial.article?.measurementUnit?.abbreviation">
                                    <input onfocus="select()" nz-input [(ngModel)]="rawMaterial.rawQuantity" type="number" />
                                </nz-input-group>
                            }@else {
                                {{rawMaterial.rawQuantity}} {{rawMaterial.article?.measurementUnit?.abbreviation}}
                            }
                        </td>

                        <td>
                            <div class="flex justify-center">
                                @if(canDelete(rawMaterial.createdById)){
                                    <button
                                    (click)="deleteRawMaterial(idx)"
                                    nz-button nzType="text" nzShape="circle" class="table-icon"
                                        [nzTooltipTitle]="'Eliminar materia prima'" nzTooltipPlacement="bottom" nz-tooltip
                                    >
                                        <span nz-icon nzType="delete"></span>
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>
                }
                </tbody>
            </nz-table>
        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button
        (click)="handleCancel()"
        class="button secondary-button mr-2"
        >
            Cancelar
        </button>

        <button nz-button class="button primary-button" (click)="handleSave()" [nzLoading]="isSaving">
            Aceptar
        </button>
    </div>
</div>
